import { Injectable, InjectionToken, inject } from '@angular/core';
import { ScriptLoaderAttributes, ScriptLoaderService } from '../script-loader.service';

export const ONE_TRUST_CONFIGURATION = new InjectionToken<OneTrustConfiguration>('oneTrustConfiguration');

export interface OneTrustConfiguration {
  oneTrustEnabled: boolean;
  oneTrustUrl: string;
  oneTrustDomainScript: string;
  initDelay?: number;
}

@Injectable({
  providedIn: 'root'
})
export class OneTrustService {
  private readonly scriptLoader = inject(ScriptLoaderService);
  private readonly oneTrustConfiguration = inject<OneTrustConfiguration>(ONE_TRUST_CONFIGURATION, { optional: true });

  init(): void {
    if (this.oneTrustConfiguration?.oneTrustEnabled) {
      this.loadOneTrustScript();
    }
  }

  loadOptanonWrapper(content: string): void {
    if(!content) {
      return;
    }

    const script: ScriptLoaderAttributes = { innerText: content };

    this.bootstrap(script);
  }

  private loadOneTrustScript(): void {
    const oneTrustScriptUrl = this.oneTrustConfiguration?.oneTrustUrl;

    if (oneTrustScriptUrl) {
      const oneTrustScript: ScriptLoaderAttributes = {
        src: oneTrustScriptUrl,
        charset: 'UTF-8',
        dataset: {
          documentLanguage: 'true',
          domainScript: this.oneTrustConfiguration?.oneTrustDomainScript
        }
      };

      this.bootstrap(oneTrustScript);
    }
  }

  //TODO: move into script-loader.service.ts
  private bootstrap(script: ScriptLoaderAttributes, initDelay: number = 1500): void {
    if(script === undefined || script === null) {
      return;
    }

    setTimeout((): void => {
      this.scriptLoader.loadScript(script);
    }, initDelay);
  }
}
